import { IGetRecordResponse } from '@principle-theorem/practice-migrations/interfaces';
import {
  PatientStatus,
  type IPatient,
} from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';
import {
  BaseExistingPatientDestinationEntity,
  type IExistingPatientMergeConflictSummary,
} from '../../../destination/entities/existing-patient';
import {
  ExactPatient,
  PatientSourceEntity,
} from '../../source/entities/patient';
import { getContactNumbers, getGender, getName } from './patient';

export class ExistingPatientDestinationEntity extends BaseExistingPatientDestinationEntity<ExactPatient> {
  patientSourceEntity = new PatientSourceEntity();

  override sourceEntities = {
    patients: this.patientSourceEntity,
  };

  getDateOfBirth(
    sourcePatient: IGetRecordResponse<ExactPatient>
  ): string | undefined {
    return sourcePatient.record.translations.dateOfBirth;
  }

  filterMatchingPatients(
    sourcePatient: IGetRecordResponse<ExactPatient>,
    matchingPatients: WithRef<IPatient>[]
  ): WithRef<IPatient>[] {
    return matchingPatients.filter(
      (patient) =>
        [
          sourcePatient.data.first_name ?? '',
          sourcePatient.data.last_name ?? '',
        ].every((name) =>
          patient.name.toLowerCase().includes(name.toLowerCase())
        ) && patient.status === PatientStatus.Active
    );
  }

  buildConflictSummary(
    sourcePatient: ExactPatient
  ): Omit<IExistingPatientMergeConflictSummary, 'status' | 'patientRefs'> {
    const sourcePatientId = this.patientSourceEntity
      .getSourceRecordId(sourcePatient.data)
      .toString();

    return {
      sourcePatientId,
      patientName: getName(sourcePatient.data),
      dateOfBirth: sourcePatient.data.date_of_birth ?? '',
      gender: getGender(sourcePatient.data),
      phone: getContactNumbers(sourcePatient.data),
      email: sourcePatient.data.email ?? '',
    };
  }
}
